import { render, staticRenderFns } from "./community.vue?vue&type=template&id=20544418&scoped=true"
import script from "./community.vue?vue&type=script&lang=js"
export * from "./community.vue?vue&type=script&lang=js"
import style0 from "./community.vue?vue&type=style&index=0&id=20544418&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20544418",
  null
  
)

export default component.exports